import { Field as BaseField } from '@base-ui/react';

import { FieldDescription } from './FieldDescription';
import { FieldError } from './FieldError';
import { FieldFooter } from './FieldFooter';
import { FieldLabel } from './FieldLabel';
import { FieldRoot } from './FieldRoot';

export const Field = {
  Root: FieldRoot,
  Label: FieldLabel,
  Footer: FieldFooter,
  Description: FieldDescription,
  Error: FieldError,
  Item: BaseField.Item,
};
